import styled from 'styled-components'

const P = styled.p`
  display: flex;
  font-family: 'Roboto', sans-serif;
  line-height: 20px;
  font-size: 20px;
  color:black;
`

export default P
